import React, { Component } from 'react';
import './WeightBenefitsTabs.css';
import _ from 'lodash';
import Tbody from './Tbody/Tbody';
import CapabilityTbody from './CapabilityTbody/CapabilityTbody';

class WeighBenefitsTabs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            
        }
    }

    componentWillMount() {
        if(!_.isEmpty(this.props.benefitsData)){
            this.setState({
                data:this.props.benefitsData
            })
        }
    }

    componentWillReceiveProps(nextProps) {
        if(!_.isEmpty(nextProps.benefitsData)){
            this.setState({
                data : nextProps.benefitsData
            })
        }
    }

    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                <div className='rect1'/>
                <div className='rect2'/>
                <div className='rect3'/>
                <div className='rect4'/>
                <div className='rect5'/>
                </div>
            </div>
        );
    }

    render() {

        let tabs = this.props.tabs.map((item,key) => {
            return (
                <li className="nav-item" key={`${item.groupId+`id`+item.segmentId}`}>
                    <a data-toggle="tab" className={key === 0 ? "nav-link active show" :"nav-link"} href={`#${item.groupId+`id`+item.segmentId}`} aria-controls={`${item.groupId+`id`+item.segmentId}`} aria-selected="true">{item.groupName+` - `+item.segmentName}</a>
            </li>)
        });

        let tabsContent = this.props.tabs.map((tabItem, key) => {
            
            const groupId = this.props.tabs.find(r => r.groupId === tabItem.groupId).groupId;
            const segmentId = this.props.tabs.find(r => r.segmentId === tabItem.segmentId).segmentId;

            return(
                <div id={groupId+`id`+segmentId} className={key === 0 ? "tab-pane fade show active tabContentdiv compete-tab-content": "tab-pane fade tabContentdiv compete-tab-content"} role="tabpanel" key={key}>
                    <div className="row">
                        <div className="col-md-6">
                            {/* {this.props.tabs.map((item, key) => { */}
                                <div className='compete-tab-content-box'>
                                    <div className="project-name">
                                        {(this.props.challengeStatementData && this.props.challengeStatementData.Count > 0 ) &&         this.props.challengeStatementData.Items.map((name, key) => {
                                                return (
                                                    <p>{name.chalange.horizon1.company}</p>
                                                )
                                            })
                                        }
                                    </div>
                                    <table className='compete-capability-table'>
                                        <thead>
                                            <tr>
                                                <th>Benefits Sought</th>
                                                <th>WT</th>
                                                <th>Critical Capability</th>
                                                <th>CC WT</th>
                                                <th>Rating <br/> (1-10)</th>
                                                <th>Score</th>
                                            </tr>
                                        </thead>
                                        <Tbody
                                            competeData={this.props.competeData}
                                            competeOldData={this.props.competeOldData}
                                            benefitsData={this.props.benefitsData}
                                            onChangeCriticalCapability={this.props.onChangeCriticalCapability}
                                            competitorsGroupsData={this.props.competitorsGroupsData}
                                            groupId={groupId}
                                            segmentId={segmentId}
                                            onChangeRatingValue={this.props.onChangeRatingValue}
                                            onChangeWT={this.props.onChangeWT}
                                        />
                                    </table>
                                </div>
                        </div>
                        <div className='col-md-5'>
                            <div className='define-tab-content-box'>                           
                                <div className='row'>
                                    {this.props.competitorsGroupsData.map((name, key) => {
                                        
                                        if(name.important){ 
                                            return(
                                                <div className='col-sm-4'>
                                                    <div className="form-group">
                                                        <select className="form-control" style={{height: "34px"}}  value={name.important ? name.competitorId : 'select'}
                                                        disabled
                                                        onChange={(e)=>this.props.onChangeCompetitors(e)}
                                                        > 
                                                            {/* <option value="select">Select</option> */}
                                                            { this.props.competitorsGroupsData.map((name, key) => {
                                                                    
                                                                        return (
                                                                            <option  value={name.competitorId}>{name.competitorName}</option>
                                                                        )
                                                                    
                                                                })
                                                            }
                                                        </select>
                                                    </div> 
                                                </div>   
                                            )
                                        }
                                    })}  
                                    <table className='compete-capability-table margin-top'>
                                        <thead>
                                            <tr>
                                                { this.props.competitorsGroupsData.map((name, key) => {
                                                    if(name.important){
                                                        return(
                                                            <th className='parent-th'>
                                                                <th className='child-th'>Rating <br/> (1-10)</th>
                                                                <th className='child-th'>Score</th>
                                                            </th>
                                                        )
                                                    }
                                                            
                                                })}
                                            </tr>
                                        </thead>
                                        <CapabilityTbody
                                            competeData={this.props.competeData}
                                            competeOldData={this.props.competeOldData}
                                            benefitsData={this.props.benefitsData}
                                            competitorsGroupsData={this.props.competitorsGroupsData}
                                            groupId={groupId}
                                            segmentId={segmentId}
                                            onChangeCompetitorsRatingValue={this.props.onChangeCompetitorsRatingValue}
                                        />  
                                    </table>                 
                                </div>  
                            </div>                             
                        </div>
                    </div>
                </div>
            )
        })

        return (
            <div className='criteria-tabs-content attractiveness-tab-content'>
                <ul className="nav nav-tabs benefitsNavTabs" role="tablist" id="myTab">
                    {tabs}
                    {/* { !_.isEmpty(this.props.attractivnessData.Items) && this.addTabs(this.props.attractivnessData.Items[0].data)} */}
                </ul>
                <div className="tab-content benefitsTabcontent" id="myTabContent" >
                    {tabsContent}
                    
                </div>
            </div>
        )
    }
}
export default (WeighBenefitsTabs);


// WEBPACK FOOTER //
// ./src/components/DifferentialAdvantage/Result/WeightBenefitsTabs/WeightBenefitsTabs.jsx